const WHATSAPP_NUMBER = '971563458521';

export const getWhatsAppUrl = (message = '') => {
  const defaultMessage = message || 'Hi! I\'m interested in getting a free website demo from Site24. Could you tell me more about your services?';
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(defaultMessage)}`;
};

export const buildContactMessage = ({ name, phone, message, businessType }) => {
  let text = `Hi Site24! I'd like to request a free website demo.\n\n`;
  if (name) text += `Name: ${name}\n`;
  if (phone) text += `Phone: ${phone}\n`;
  if (businessType) text += `Business Type: ${businessType}\n`;
  if (message) text += `\nMessage: ${message}`;
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(text)}`;
};

export default getWhatsAppUrl;
